import React from 'react';
import { CheckboxInputContainer } from '../../checkbox/containers/checkbox-input.container';
import { DateInputContainer } from '../../date/containers/date-input.container';
import { NumberInputContainer } from '../../number/containers/number-input.container';
import { PasswordInputContainer } from '../../password/containers/password-input.container';
import { SelectInputContainer } from '../../select/containers/select-input.container';
import { TextInputContainer } from '../../text/containers/text-input.container'
import { TypeaheadInputContainer } from '../../typeahead/containers/typeahead-input.container';
import { MultiSelectContainer } from '../../multiselect/containers/multi-select.container';
import { MultiSelectTextContainer } from '../../multi-select-text/containers/multi-select-text.container';
import { QuillEditorInputContainer } from '../../quill-editor/containers/quil-editor-input.container';
import { PhoneNumberInputContainer } from '../../phone-number-text/containers/phone-number-input.container';


// eslint-disable-next-line complexity
export function InputComponent({ min, optionName, readOnly, isDateTimePicker, disablePast, valueField, checked, key, onTypeahead, icon, name, rows, multiline, label, value, type, onValueChange, placeholder, list, className, labelField, isDisabled, isRequired }: any) {
  switch (type) {
    case 'select':
      return (<SelectInputContainer
        className={className}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        labelField={labelField}
        list={list}
        name={name}
        onTypeahead={onTypeahead}
        onValueChange={onValueChange}
        value={value}
        valueField={valueField}
        optionName={optionName}
      />)
    case 'typeahead':
      return (<TypeaheadInputContainer
        className={className}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        labelField={labelField}
        list={list}
        name={name}
        onTypeahead={onTypeahead}
        onValueChangeCallback={onValueChange}
        placeholder={placeholder}
        value={value}
        valueField={valueField}
      />)
    case 'number':
      return (<NumberInputContainer
        icon={icon}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        name={name}
        min={min}
        onValueChange={onValueChange}
        placeholder={placeholder}
        type={type}
        value={value}
      />)
    case 'phonenumber':
      return (<PhoneNumberInputContainer
        min={min}
        icon={icon}
        type={type}
        name={name}
        label={label}
        value={value}
        onValueChange={onValueChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isRequired={isRequired}
      />)
    case 'password':
      return (<PasswordInputContainer
        icon={icon}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        name={name}
        onValueChange={onValueChange}
        placeholder={placeholder}
        type={type}
        value={value}
      />)
    case 'date':
      return (<DateInputContainer
        icon={icon}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        name={name}
        isDateTimePicker={isDateTimePicker}
        disablePast={disablePast}
        onValueChange={onValueChange}
        placeholder={placeholder}
        type={type}
        value={value}
      />)
    case 'checkbox':
      return (<CheckboxInputContainer
        isDisabled={isDisabled}
        label={label}
        name={name}
        onValueChange={onValueChange}
        type={type}
        value={value}
      />)
    case 'rte':
      return (<QuillEditorInputContainer
        isRequired={isRequired}
        label={label}
        name={name}
        onValueChange={onValueChange}
        type={type}
        value={value}
        readOnly={readOnly}
      />)
    case 'multiselect':
      return (<MultiSelectContainer
        className={className}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        labelField={labelField}
        list={list}
        name={name}
        onTypeahead={onTypeahead}
        onValueChangeCallback={onValueChange}
        value={value}
        valueField={valueField}
        optionName={optionName}
      />)
    case 'multiselectText':
      return (<MultiSelectTextContainer
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        onValueChangeCallback={onValueChange}
        value={value}
      />)
    case 'text':
    default:
      return (<TextInputContainer
        icon={icon}
        isDisabled={isDisabled}
        isRequired={isRequired}
        label={label}
        multiline={multiline}
        name={name}
        onValueChange={onValueChange}
        placeholder={placeholder}
        rows={rows}
        type={type}
        value={value}
      />)

  }
}
